import { Component, Input, OnInit } from '@angular/core';
import { PersonOffTimeService } from 'src/app/Service/Person/PersonOffTime.service';

@Component({
  selector: 'app-PersonOffTimeView',
  templateUrl: './PersonOffTimeView.component.html',
  styleUrls: ['./PersonOffTimeView.component.css']
})
export class PersonOffTimeViewComponent implements OnInit {

  @Input() inner_offtime_id:number=0

  constructor(
    private Person_Service:PersonOffTimeService,

  ) { }

  ngOnInit() {
    this.CheckOfftime()
  }

  startTime_fulldate:string=''
  endTime_fulldate:string=''
  requestDate:string=''
  dsc:string=''


  CheckOfftime(){

    this.Person_Service.GetSingleOfftime(this.inner_offtime_id).subscribe(
      data=>{


        this.startTime_fulldate=data['startTime_fulldate']
        this.endTime_fulldate=data['endTime_fulldate']
        this.requestDate=data['requestDate']

        this.dsc=data['dsc']

      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
        
      }
    )
  }

}
